import { createGradientOrSolid } from "../Helper/utils";
import styled from "styled-components";

export const StyledActionButton = styled.button`
    outline: 0;
    border: 0;
    width: 310px;
    height: 60px;
    border-radius: 7px;
    background: ${(props: any) => createGradientOrSolid(props.colors)};
    border: ${(props: any) => props.border || 'none'};
    font-family: ${(props: any) => props.font || 'inherit'};
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    img {
        height: 22px;
    }
` as any;
